import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



if ('serviceWorker' in navigator) {
  window.addEventListener(
    'load',
    () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(registration => {
          console.log(
            '[PWA] Service Worker registrado:',
            registration.scope
          );
        })
        .catch(error => {
          console.error(
            '[PWA] Falha ao registrar Service Worker:',
            error
          );
        });
    }
  );
}
